export const STARTING_STATUS = 'STARTING_STATUS';
export const NOT_FOUND_404 = 'NOT_FOUND_404';
export const END_ALL = "END_ALL";
export const LOADING_0 = 'LOADING_0';
export const SUCCESS_200 = 'SUCCESS_200';

export let flag_1Carga = true;
